import React, { useState } from 'react'
import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'
import { colors } from '../../../../styles/colors'
import { Cross } from '../../../UI/Cross'
import { getCalculatedSum } from '../../../../functions/getCalculatedSum'
import { ProductSlider } from './ProductSlider'
import { ProductPrice } from './ProductPrice'
import { AddToCartBlock } from './AddToCartBlock'
import { ProductDescription } from './ProductDescription'

const Container = styled.article`

width: 100%;
height: 100%;
overflow: auto;

position: fixed;
top: 0:
left: 0;
z-index: 10;
background: rgba(255, 255, 255, 0.5);

padding: 10rem 2rem;

// INCLUDED CLASSES:

.product-box {
    max-width: 1300px;
    margin: 0 auto;

    padding: 10rem;
    position: relative;
    
    background: ${colors.white};
    border: 1px solid ${colors.dark_blue};
    
    @media (max-width: 767.98px) {
        padding: 7.5rem 4rem;
    }
    @media (max-width: 320px) {
        padding: 7.5rem 2rem;
    }
}

.cross-button {
    top: 5rem;
    right: 5rem;
}
.product-name {
    font-family: 'SF UI Text', sans-serif;
    font-weight: 400;
    font-size: 2.75rem;
    line-height: 160%;
    margin-bottom: 5rem;
    text-transform: uppercase;
    
    @media (max-width: 320px) {
        margin-bottom: 1rem;
    }
}
  
.content-wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;

    @media (max-width: 959.98px) {
        flex-direction: column;
    }
}
.content-1 {
    width: 100%;
    @media (min-width: 1300px) {
        margin-left: 5rem;
    }
}
.descriptions {
    @media (min-width: 768px) and (max-width: 1299.98px ) {
        margin-left: 5rem;
    }
}
`

export const ProductPage = () => {

    const dispatch = useDispatch()

    const product_data = useSelector(state => state.product_page.product_data)

    const product_pictures = product_data.pictures
    const product_tech_description = product_data.tech_props
    const product_description = product_data.description
    const product_name = product_data.product_name
    const price = product_data.price
    const id = product_data.key

    const [count, setCount] = useState(1)

    return (
        <Container>

            <div className="product-box">
                <div onClick={() => dispatch({ type: 'PRODUCT_PAGE_CLOSED' })}><Cross /></div>

                <div className="product-name"> {product_name} </div>

                <div className="content-wrapper">

                    {product_pictures 
                        ? <ProductSlider pictures={product_pictures} /> 
                        : null
                    }

                    <div className='content-1'>

                        <ProductPrice>{getCalculatedSum(price, count)}</ProductPrice>

                        <AddToCartBlock 
                            count={count}
                            product_name={product_name}
                            id={id}
                            price={price}
                            product_picture={product_pictures[0].url}
                            setCount={setCount}
                        />

                        <div className="descriptions">
                            {product_description
                                ? <ProductDescription
                                    description={product_description}
                                    title='Описание'
                                    id='main-description'
                                />
                                : null
                            }

                            {product_tech_description
                                ? <ProductDescription
                                    description={product_tech_description}
                                    title='Технические характеристики'
                                    id='tech-properties'
                                />
                                : null
                            }
                        </div>

                    </div>
                </div>
            </div>

        </Container>
    )
}
